export default class IntroPlayer extends Phaser.Group {
  constructor(game, introDisplayed) {
    super(game);
    this.data = {
      skeletons: [
        'spine_intro_audio',
        'spine_intro_bg',
        'spine_intro_butterfly2',
        'spine_intro_butterfly',
        'spine_intro_elinor',
        'spine_intro_ari',
        'spine_intro_olive',
      ],
      audio_skeleton_id: 'spine_intro_audio',
    };

    //

    this.audioSkeleton = null;

    // build scene
    this.makeScene();

    // set anims
    this.setAnim(introDisplayed);
  }

  makeScene() {
    this.skeletons = {};
    for (let i = 0; i < this.data.skeletons.length; i++) {
      const name = this.data.skeletons[i];
      const skel = this.game.make.spine(0, 0, name, true);
      skel.anchor.set(0.5, 1);
      this.skeletons[name] = skel;
      this.addChild(skel);

      //
      if (name === this.data.audio_skeleton_id) {
        this.audioSkeleton = skel;
        this.audioSkeleton.onEvent.add(this.handleAudioEvent, this);
      }
    }

    this.skeletons['spine_intro_elinor'].setSkinByName('body');
    this.skeletons['spine_intro_ari'].setSkinByName('body');
    this.skeletons['spine_intro_olive'].setSkinByName('body');
  }

  handleAudioEvent(track, event) {
    track;
    console.log(event.data.name);
    this.game.controller.playVO(event.data.name);
  }

  setAnim(introDisplayed) {
    this.tracks = [];
    this.tracks.push(this.skeletons['spine_intro_bg'].setAnimationByName(0, 'animation', false));
    this.tracks.push(
      this.skeletons['spine_intro_butterfly2'].setAnimationByName(0, '3_butterfly_loop', true)
    );
    this.tracks.push(
      this.skeletons['spine_intro_butterfly'].setAnimationByName(0, '3_butterfly_loop', true)
    );

    // some anims vary depending if it is first time or not
    if (!introDisplayed) {
      // first time -> full intro
      this.tracks.push(
        this.skeletons['spine_intro_audio'].setAnimationByName(0, '01_intro', false)
      );
      this.tracks.push(
        this.skeletons['spine_intro_elinor'].setAnimationByName(0, '01_intro', false)
      );
      this.skeletons['spine_intro_elinor'].addAnimationByName(0, '02_loop', true);
      this.tracks.push(this.skeletons['spine_intro_ari'].setAnimationByName(0, '01_intro', false));
      this.skeletons['spine_intro_ari'].addAnimationByName(0, '02_loop', true);
      this.tracks.push(
        this.skeletons['spine_intro_olive'].setAnimationByName(0, '01_intro', false)
      );
      this.skeletons['spine_intro_olive'].addAnimationByName(0, '02_loop', true);
    } else {
      // second time
      this.tracks.push(this.skeletons['spine_intro_audio'].setAnimationByName(0, '02_loop', false));
      this.tracks.push(this.skeletons['spine_intro_elinor'].setAnimationByName(0, '02_loop', true));
      this.tracks.push(this.skeletons['spine_intro_ari'].setAnimationByName(0, '02_loop', true));
      this.tracks.push(this.skeletons['spine_intro_olive'].setAnimationByName(0, '02_loop', true));
    }

    //
    for (let i = 0; i < this.tracks.length; i++) {
      this.tracks[i].timeScale = 0;
    }
  }

  playAnim() {
    for (let i = 0; i < this.tracks.length; i++) {
      this.tracks[i].timeScale = 1;
    }
  }

  destroy() {
    if (this.btnSkip) {
      this.btnSkip.destroy();
      this.btnSkip = null;
    }

    // stop VO and captions
    this.game.controller.stopVO();

    //
    for (let i = 0; i < this.skeletons.length; i++) {
      this.removeChild(this.skeletons[i]);
      if (this.skeletons[i]) {
        this.skeletons[i].destroy();
      }
    }
    this.skeletons = null;

    super.destroy();
  }
}
